import { KeycloakConfig } from "keycloak-js";
import { Config } from "../../config";

export function getKdClientId(config: Config) {
    const keycloakConfig = config.identityProvider.keycloakConfig as KeycloakConfig;
    const kdConfig = config.knowledgeDesigner;

    return kdConfig?.keycloakEffectiveClientId || keycloakConfig.clientId;
}